/* =========================================================================
   MARKETING Hero — Scaling Advisor: shared types & constants.
   Classifies a campaign and gives a scale/hold/kill decision with a plan,
   plus a period-over-period comparison.
   ========================================================================= */

export const CLASSIFICATIONS: Record<string, { label: string; pill: string }> = {
  winner: { label: "Winner — ตัวชนะ", pill: "mh-pill--winner" },
  scale_candidate: { label: "Scale Candidate — พร้อมขยาย", pill: "mh-pill--winner" },
  watch: { label: "Watch — เฝ้าดู", pill: "mh-pill--watch" },
  problem: { label: "Problem — มีปัญหา", pill: "mh-pill--problem" },
  testing: { label: "Testing — กำลังทดสอบ", pill: "mh-pill--testing" },
  insufficient: { label: "Insufficient Data — ข้อมูลไม่พอ", pill: "mh-pill--neutral" },
};

export const RECOMMENDATIONS: Record<string, string> = {
  scale: "Scale — ขยายงบ",
  increase_slowly: "Increase Slowly — เพิ่มงบทีละน้อย",
  hold: "Hold — คงไว้",
  duplicate: "Duplicate — ก๊อปแล้วขยาย",
  test_more: "Test More — ทดสอบเพิ่ม",
  new_creative: "New Creative — เติมครีเอทีฟใหม่",
  new_audience: "New Audience — ลองกลุ่มใหม่",
  expand: "Expand — ขยายกลุ่ม",
  retarget: "Retarget — ทำรีทาร์เก็ต",
  do_not_scale: "Do Not Scale — ยังไม่ควรขยาย",
};

export interface ScalingMetrics {
  spend?: number | null; lead?: number | null; cpl?: number | null; leadQuality?: string;
  sale?: number | null; revenue?: number | null; roas?: number | null; frequency?: number | null;
  creativeAgeDays?: number | null; daysRunning?: number | null;
}

export interface ScalingOutput {
  classification: string;
  classificationReason: string;
  analysis: { aspect: string; reading: string; tone: "ok" | "warn" | "bad" | "neutral" }[];
  recommendation: string;
  recommendationLabel: string;
  reason: string;
  risk: string;
  plan: string[];
  whatToWatch: string;
  reviewPoint: string;
  disclaimer?: string;
}

export interface ComparisonRow { metric: string; current: number | null; previous: number | null; changePct: number | null; tone: "ok" | "warn" | "bad" | "neutral"; }
export interface ComparisonOutput { rows: ComparisonRow[]; explanation: string; }

export const SCALING_SCHEMA_HINT = {
  classification: "winner|scale_candidate|watch|problem|testing|insufficient",
  classificationReason: "string",
  analysis: [{ aspect: "string เช่น ความเสถียร/ROAS/Frequency/Creative Age/Audience/Trend/Risk", reading: "string", tone: "ok|warn|bad|neutral" }],
  recommendation: "scale|increase_slowly|hold|duplicate|test_more|new_creative|new_audience|expand|retarget|do_not_scale",
  recommendationLabel: "string",
  reason: "string", risk: "string", plan: ["string"], whatToWatch: "string", reviewPoint: "string",
};
